import React from 'react';
import {InputTextarea} from 'primereact/inputtextarea';

interface CenteredTextareaProps {
  id: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  label: string;
  icon?: string;
  required?: boolean;
  rows?: number;
}

const CenteredTextarea: React.FC<CenteredTextareaProps> = ({
                                                             id,
                                                             name,
                                                             value,
                                                             onChange,
                                                             placeholder,
                                                             label,
                                                             icon,
                                                             required = false,
                                                             rows = 5
                                                           }) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <div className="relative">
        <InputTextarea
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          rows={rows}
          className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent transition duration-300"
        />
        {icon && (
          <i className={`absolute right-3 top-4 text-gray-400 ${icon}`}/>
        )}
      </div>
    </div>
  );
};

export default CenteredTextarea;

